module.exports = __webpack_public_path__ + "static/assets/4edd383da41c26587d94ac5fdfbc3450.png";